/** @jsxRuntime automatic */
/* eslint-disable react-refresh/only-export-components -- Store module exports provider and hooks. */
import {
  createContext,
  useContext,
  useMemo,
  useReducer,
  type Dispatch,
  type ReactNode,
} from 'react';
import { useT } from '../i18n/I18nProvider';
import { createInitialTabState, tabReducer, type TabAction, type TabState } from './tabReducer';

interface TabStoreValue {
  state: TabState;
  dispatch: Dispatch<TabAction>;
}

const TabStoreContext = createContext<TabStoreValue | null>(null);

export function TabProvider({ children }: { children: ReactNode }) {
  const t = useT();
  const [state, dispatch] = useReducer(tabReducer, t('tab.newChat'), createInitialTabState);
  const value = useMemo(() => ({ state, dispatch }), [state]);

  return <TabStoreContext.Provider value={value}>{children}</TabStoreContext.Provider>;
}

export function useTabStore(): TabStoreValue {
  const value = useContext(TabStoreContext);
  if (!value) {
    throw new Error('useTabStore must be used within a TabProvider');
  }
  return value;
}

export function useTabState(): TabState {
  return useTabStore().state;
}

export function useTabDispatch(): Dispatch<TabAction> {
  return useTabStore().dispatch;
}